// Calendly block schema - Embed a Calendly booking button
export const calendlySchema = {
  type: 'calendly',
  label: 'Calendly',
  description: 'Embed a Calendly booking button',
  icon: 'Calendar',
  defaultContent: {
    calendlyUrl: '',
    buttonText: 'Schedule a Meeting',
    style: {},
  },
  fields: [
    { name: 'calendlyUrl', label: 'Calendly URL', type: 'text', placeholder: 'https://calendly.com/your-name', required: true },
    { name: 'buttonText', label: 'Button Text', type: 'text', placeholder: 'Schedule a Meeting' },
  ],
};
